import axios from 'axios';
import Comprobante from '@/models/Comprobante';
function defaultState() {
	return {
		allTableData: [],
	};
}
const state = defaultState();
const getters = {};
const mutations = {
	setAllTableData(state: { allTableData: Comprobante[] }, data: Comprobante[]) {
		state.allTableData = data;
	},
};
const actions = {
	async loadExpand({ commit }, params: { data: object; url: string; contrato: boolean }) {
		let response = await axios.get(params.url, params.data).then(response => {
			if (!params.contrato) {
				axios
					.get('./api/public/proxy/cgi/etenet_fichadet', this.loadConfig)
					.then(response => {
						if (response.data.success) commit('setAllTableData', response.data.items);
					})
					.catch(error => {
						console.log('ERROR', error);
					});
			}
			return response;
		});
		return response;
	},
	reset(): void {
		Object.assign(state, defaultState());
	},
};
export default {
	state,
	getters,
	actions,
	mutations,
};
